import {Component, Input} from '@angular/core';
import {NgModel} from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-form-input-errors',
    templateUrl: './form-input-errors.component.html',
    styleUrls: ['./form-input-errors.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class FormInputErrorsComponent {

  @Input()
  public input: NgModel;
}
